import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade dc_modal_appcloud",
  tabindex: "-1",
  role: "dialog",
  id: "dc_appclouddialog"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content rounded-8" }
const _hoisted_4 = { class: "modal-header d-flex flex-row" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column flex-grow-1 gap-2"
}
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = {
  key: 1,
  class: "modal-title d-flex flex-column justify-content-center flex-grow-1"
}
const _hoisted_8 = { class: "titre" }
const _hoisted_9 = { class: "versiontitre" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "close float-end mt-2 align-self-start",
  "data-bs-dismiss": "modal"
}, "✕", -1 /* HOISTED */)
const _hoisted_11 = { class: "modal-body" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-column gap-3 installpart mt-3"
}
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = { class: "textbottom" }
const _hoisted_16 = { class: "d-flex flex-row gap-3 justify-content-center align-items-center mt-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-desktop" }, null, -1 /* HOISTED */)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 1,
  class: "d-flex flex-column gap-3 installpart mt-3"
}
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = { class: "textbottom" }
const _hoisted_22 = { class: "d-flex flex-row gap-3 justify-content-center align-items-center mt-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sync" }, null, -1 /* HOISTED */)
const _hoisted_24 = {
  key: 2,
  class: "d-flex flex-column gap-3 installpart mt-3"
}
const _hoisted_25 = { class: "mt-4" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "d-flex flex-row gap-3 justify-content-center align-items-center mt-3" }

import { ref, Ref, onMounted, watch, getCurrentInstance } from 'vue';
    import DcappcloudComponent from './../Shared/Components/ProgressDetection/DcappcloudComponent.vue';
    import vueinstallapp from './../Shared/vueinstallapp.vue';
    import * as bootstrap from "bootstrap";
    import { MCRedirectSubmitUrl } from './../Shared/AppCloudModel';
    import { selectControlModel } from './../Shared/selectControlModel';
    import { InstallAppApiViewModel } from '../../Views/startdetection/index';
    import axios, { AxiosResponse } from 'axios';
    import { useLoginStore } from './Stores/LoginStore';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressDetection',
  props: {
    isconnect: { type: Boolean },
    view_loginmodal_infos: {},
    view_startdetect_modalinstalldesc: {},
    view_startdetect_installtitre: {},
    mcdriversversion: {},
    action: {},
    startdetect: { type: Boolean },
    lan: {},
    authuserurl: {},
    urlconfig: {},
    urlconfigauth: {},
    urlmonitor: {},
    service: {},
    installmodep: { type: Boolean },
    dcappcloud_desc: {},
    dcappcloud_all: {},
    dcappcloud_none: {},
    dcappcloud_installedagent: {},
    dcappcloud_but_startdetect: {},
    dcappcloud_but_terminatedetect: {},
    dcappcloud_but_installdrivers: {},
    dcappcloud_but_createrestorepoint: {},
    dcappcloud_but_savealldrivers: {},
    dcappcloud_but_startmonitoring: {},
    dcappcloud_but_stopmonitoring: {},
    dcappcloud_but_connect: {},
    dcappcloud_desc_connect: {},
    dcappcloud_emptyconnectedlist_notconnect: {},
    dcappcloud_emptyconnectedlist_connect: {},
    dcappcloud_listconnected: {},
    dcappcloud_noinstalledagent: {},
    dcappcloud_agent_errconnect_notinstalled: {},
    dcappcloud_agent_errconnect_nosupport: {},
    progressdetection_onservice: {},
    progressdetection_installtitle: {},
    progressdetection_installdesc: {},
    progressdetection_installbtn: {},
    progressdetection_analysetitle: {},
    progressdetection_analysedesc: {},
    progressdetection_analysebtn: {},
    progressdetection_pardefault: {},
    progressdetection_pilotes: {},
    progressdetection_configuration: {},
    progressdetection_bsod: {},
    progressdetection_monitoring: {},
    startdetection_mustaccount: {},
    view_startdetect_modalhasinstallauto: {},
    view_startdetect_modalhasinstallmsi: {},
    dcstartdetect_modal_install_mandatory: {},
    view_startdetect_modal_manual_title: {},
    view_startdetect_modal_manual_desc: {},
    view_startdetect_modal_subtitle_32: {},
    view_startdetect_modal_subtitle_64: {},
    view_startdetect_modalor: {},
    progressdetection_manual_analysetitle: {},
    progressdetection_manual_analysedesc: {},
    progressdetection_manual_terminate_but: {}
  },
  setup(__props: any) {

    const props = __props;

    const servicecurrent: Ref<number> = ref(props.service);
    const actioncurrent: Ref<number> = ref(props.action);
    const viewappli: Ref<InstallAppApiViewModel | null> = ref(null);
    const modalconn: Ref<any> = ref(null);
    const installmode: Ref<boolean> = ref(props.installmodep);
    const isinstallauto: Ref<boolean> = ref(true);
    const selectmenu: Ref<selectControlModel[]> = ref([]);
    const isFromOtherModal: Ref<boolean> = ref(false);
    const isinit: Ref<boolean> = ref(true);

    onMounted(() => {
        initSelect();
        $('#dc_appclouddialog').on('show.bs.modal', function (e: any) {
            isinit.value = true;
            isFromOtherModal.value = false;
            const installMode: boolean = $(e.relatedTarget).data('installmode');
            const isInstallAuto: boolean = $(e.relatedTarget).data('installauto');
            const actiondata = $(e.relatedTarget).data('action');
            const servicedata = $(e.relatedTarget).data('service');

            isinstallauto.value = isInstallAuto;

            if (actiondata != null) {
                actioncurrent.value = actiondata;
            }

            if (servicedata != null) {
                servicecurrent.value = servicedata;
            }

            SetInstallMode(installMode, isinit.value);
            isinit.value = false;
        });

        if (props.startdetect) {
            if (props.isconnect) {
                DCOpenAppCloudModal(null);
            }
            else {
                const store = useLoginStore();
                store.DCOpenLoginModal(null, props.startdetection_mustaccount);
            }
        }
    });

    function initSelect() {
        selectmenu.value = [];
        selectmenu.value.push(new selectControlModel(MCRedirectSubmitUrl.DEFAULT, props.progressdetection_pardefault));
        selectmenu.value.push(new selectControlModel(MCRedirectSubmitUrl.DRIVERS, props.progressdetection_pilotes));
        selectmenu.value.push(new selectControlModel(MCRedirectSubmitUrl.CONFIG, props.progressdetection_configuration));
        selectmenu.value.push(new selectControlModel(MCRedirectSubmitUrl.BSOD, props.progressdetection_bsod));
        selectmenu.value.push(new selectControlModel(MCRedirectSubmitUrl.MONITORING, props.progressdetection_monitoring));
    }

    function DCOpenAppCloudModal(event: any) {
        if (event != null)
            event.preventDefault();
        let elt = document.getElementById('dc_appclouddialog');
        if (elt !== null) {
            modalconn.value = new bootstrap.Modal(elt, {});
            modalconn.value.show();
        }
    }

    function terminateManualInstallModal() {
        $('#dc_appclouddialog').modal('hide');
        const offsetHorsLigneBloc: number = ($('#blocservicehorsligne')?.offset()?.top ?? 0);
        $('html, body').animate({ scrollTop: offsetHorsLigneBloc - 90 }, 100);
    }

    async function DetectionModalLoad(url: string) {
        const response: AxiosResponse<InstallAppApiViewModel> = await axios.get<InstallAppApiViewModel>(url);
        if (response.data !== null) {
            viewappli.value = response.data;
            installmode.value = true;
            }
    }

    async function SetInstallMode(mode: boolean, init: boolean=false) {
        if (mode) {
            let url: string = "/api/v1/startdetection/InstallApp?lancurrent=" + props.lan;
            await DetectionModalLoad(url);
        }
        else {
            installmode.value = false;
            viewappli.value = null;
        }
        if (!init) {
            isFromOtherModal.value = true;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!installmode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("h4", _hoisted_6, [
                  (actioncurrent.value == 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_startdetect), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (actioncurrent.value == 3)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_createrestorepoint), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (actioncurrent.value == 4)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.dcappcloud_but_savealldrivers), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          (installmode.value&&viewappli.value)
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.view_startdetect_installtitre), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.mcdriversversion) + " (" + _toDisplayString(viewappli.value.m_configversionstr) + ")", 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _hoisted_10
        ]),
        _createElementVNode("div", _hoisted_11, [
          (!installmode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(DcappcloudComponent, {
                  lan: _ctx.lan,
                  isconnect: _ctx.isconnect,
                  service: servicecurrent.value,
                  authuserurl: _ctx.authuserurl,
                  urlconfig: _ctx.urlconfig,
                  urlconfigauth: _ctx.urlconfigauth,
                  urlmonitor: _ctx.urlmonitor,
                  action: actioncurrent.value,
                  dcappcloud_desc: _ctx.dcappcloud_desc,
                  dcappcloud_all: _ctx.dcappcloud_all,
                  dcappcloud_none: _ctx.dcappcloud_none,
                  dcappcloud_installedagent: _ctx.dcappcloud_installedagent,
                  dcappcloud_but_startdetect: _ctx.dcappcloud_but_startdetect,
                  dcappcloud_but_terminatedetect: _ctx.dcappcloud_but_terminatedetect,
                  dcappcloud_but_installdrivers: _ctx.dcappcloud_but_installdrivers,
                  dcappcloud_but_createrestorepoint: _ctx.dcappcloud_but_createrestorepoint,
                  dcappcloud_but_savealldrivers: _ctx.dcappcloud_but_savealldrivers,
                  dcappcloud_but_startmonitoring: _ctx.dcappcloud_but_startmonitoring,
                  dcappcloud_but_stopmonitoring: _ctx.dcappcloud_but_stopmonitoring,
                  dcappcloud_but_connect: _ctx.dcappcloud_but_connect,
                  dcappcloud_desc_connect: _ctx.dcappcloud_desc_connect,
                  dcappcloud_emptyconnectedlist_notconnect: _ctx.dcappcloud_emptyconnectedlist_notconnect,
                  dcappcloud_emptyconnectedlist_connect: _ctx.dcappcloud_emptyconnectedlist_connect,
                  dcappcloud_listconnected: _ctx.dcappcloud_listconnected,
                  dcappcloud_noinstalledagent: _ctx.dcappcloud_noinstalledagent,
                  dcappcloud_agent_errconnect_notinstalled: _ctx.dcappcloud_agent_errconnect_notinstalled,
                  dcappcloud_agent_errconnect_nosupport: _ctx.dcappcloud_agent_errconnect_nosupport
                }, null, 8 /* PROPS */, ["lan", "isconnect", "service", "authuserurl", "urlconfig", "urlconfigauth", "urlmonitor", "action", "dcappcloud_desc", "dcappcloud_all", "dcappcloud_none", "dcappcloud_installedagent", "dcappcloud_but_startdetect", "dcappcloud_but_terminatedetect", "dcappcloud_but_installdrivers", "dcappcloud_but_createrestorepoint", "dcappcloud_but_savealldrivers", "dcappcloud_but_startmonitoring", "dcappcloud_but_stopmonitoring", "dcappcloud_but_connect", "dcappcloud_desc_connect", "dcappcloud_emptyconnectedlist_notconnect", "dcappcloud_emptyconnectedlist_connect", "dcappcloud_listconnected", "dcappcloud_noinstalledagent", "dcappcloud_agent_errconnect_notinstalled", "dcappcloud_agent_errconnect_nosupport"]),
                (!installmode.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.progressdetection_installtitle), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.progressdetection_installdesc), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("button", {
                          id: "dcinstallbut",
                          class: "btn btn-modalbottom",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (SetInstallMode(true, false)))
                        }, [
                          _hoisted_17,
                          _createTextVNode(_toDisplayString(_ctx.progressdetection_installbtn), 1 /* TEXT */)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (installmode.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (installmode.value)
                  ? (_openBlock(), _createBlock(vueinstallapp, {
                      key: 0,
                      isinstallauto: isinstallauto.value,
                      viewappli: viewappli.value,
                      dc_descpilotesreferer: "",
                      view_loginmodal_infos: _ctx.view_loginmodal_infos,
                      view_startdetect_modalinstalldesc: _ctx.view_startdetect_modalinstalldesc,
                      view_startdetect_modalhasinstallauto: _ctx.view_startdetect_modalhasinstallauto,
                      view_startdetect_modalhasinstallmsi: _ctx.view_startdetect_modalhasinstallmsi,
                      dcstartdetect_modal_install_mandatory: _ctx.dcstartdetect_modal_install_mandatory,
                      view_startdetect_modal_manual_title: _ctx.view_startdetect_modal_manual_title,
                      view_startdetect_modal_manual_desc: _ctx.view_startdetect_modal_manual_desc,
                      view_startdetect_modal_subtitle_32: _ctx.view_startdetect_modal_subtitle_32,
                      view_startdetect_modal_subtitle_64: _ctx.view_startdetect_modal_subtitle_64,
                      view_startdetect_modalor: _ctx.view_startdetect_modalor
                    }, null, 8 /* PROPS */, ["isinstallauto", "viewappli", "view_loginmodal_infos", "view_startdetect_modalinstalldesc", "view_startdetect_modalhasinstallauto", "view_startdetect_modalhasinstallmsi", "dcstartdetect_modal_install_mandatory", "view_startdetect_modal_manual_title", "view_startdetect_modal_manual_desc", "view_startdetect_modal_subtitle_32", "view_startdetect_modal_subtitle_64", "view_startdetect_modalor"]))
                  : _createCommentVNode("v-if", true),
                (isinstallauto.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.progressdetection_analysetitle), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.progressdetection_analysedesc), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("button", {
                          id: "dcinstallbut",
                          class: "btn btn-modalbottom",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (SetInstallMode(false, false)))
                        }, [
                          _hoisted_23,
                          _createTextVNode(_toDisplayString(_ctx.progressdetection_analysebtn), 1 /* TEXT */)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true),
                (!isinstallauto.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.progressdetection_manual_analysetitle), 1 /* TEXT */),
                      _createElementVNode("div", {
                        class: "textbottom",
                        innerHTML: _ctx.progressdetection_manual_analysedesc
                      }, null, 8 /* PROPS */, _hoisted_26),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("button", {
                          id: "dcinstallbut",
                          class: "btn btn-modalbottom",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (terminateManualInstallModal()), ["prevent"]))
                        }, _toDisplayString(_ctx.progressdetection_manual_terminate_but), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}
}

})